export default __webpack_public_path__ + "static/media/loading.5e2d49ed.gif";